w
<template>
  <div id="mapsTabs">
    <hr class="tall solid" id="mapContainer" />
    <div class="row no-row-padding">
      <div class="tabs col-md-12">
        <ul
          class="nav nav-tabs nav-justified flex-column flex-md-row"
          role="tablist_map"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="map-tab"
              data-toggle="tab"
              href="#map"
              role="tab"
              aria-controls="map"
              aria-selected="true"
              @click="selectTab('map')"
            >
              <i class="far fa-map"></i>
              <strong>{{ $t("components.mapsTabs.map") }}</strong>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="satellite-tab"
              data-toggle="tab"
              href="#satellite"
              role="tab"
              aria-controls="satellite"
              aria-selected="false"
              @click="selectTab('satellite')"
            >
              <i class="fas fa-map"></i>
              <strong>{{ $t("components.mapsTabs.satellite") }}</strong>
            </a>
          </li>
          <li class="nav-item" v-if="hasStreetView">
            <a
              class="nav-link"
              id="streetView-tab"
              data-toggle="tab"
              href="#streetView"
              role="tab"
              aria-controls="streetView"
              aria-selected="false"
              @click="selectTab('streetView')"
            >
              <i class="fas fa-street-view"></i>
              <strong>{{ $t("components.mapsTabs.streetView") }}</strong>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            class="tab-pane active"
            id="map"
            role="tabpanel"
            aria-labelledby="map-tab"
          >
            <Map :center="this.coordinates" :zoom="15" type="roadmap"></Map>
          </div>
          <div
            class="tab-pane"
            id="satellite"
            role="tabpanel"
            aria-labelledby="satellite-tab"
          >
            <Map :center="this.coordinates" :zoom="18" type="satellite"></Map>
          </div>
          <div
            v-if="hasStreetView"
            class="tab-pane"
            id="streetView"
            role="tabpanel"
            aria-labelledby="streetView-tab"
          >
            <iframe
              :src="streetView"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: 0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Map from "@/components/common/Map";
export default {
  name: "MapsTabs",
  components: {
    Map,
  },
  props: {
    coordinates: {
      type: Object,
      default: function () {
        return {};
      },
    },
    streetView: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  methods: {
    selectTab: function (tabId) {
      $(`#${tabId}`).tab("show");
    },
    isDefined: function (value) {
      return value !== undefined && value !== null && value.trim() !== "";
    },
  },
  computed: {
    hasStreetView: function () {
      return this.isDefined(this.streetView);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  max-height: 600px;
  height: 60vh;
}
.nav-link.active {
  border-top-color: $primary-color;
}

.nav-tabs.nav-justified li .nav-link {
  border-bottom: none;
}

.nav-link.active.show {
  background-color: white;
}

.nav-link > i {
  padding-right: 5px !important;
}
</style>
